import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { userHasWarrantyEnabledRedir } from '../core/auth';
import ClaimDetail from '../views/claimDetail/containers/ClaimDetail';
import ClaimsViews from '../views/claims/components/ClaimsViews';
import ClaimReports from '../views/claims/containers/ClaimReports';
import Claims from '../views/claims/containers/Claims';
import ReclamationEdit from '../views/reclamations/containers/ReclamationEdit';
import ReclamationFormWrapper from '../views/reclamations/containers/ReclamationFormWrapper';
import DamageOptions from '../views/claims/containers/DamageOptions';

const ClaimsWithCreateDrawer = () => (
  <>
    <Claims />
    <ReclamationFormWrapper />
  </>
);

const ClaimsWithCompleteDrawer = () => (
  <>
    <Claims />
    <ReclamationEdit completeMode />
  </>
);

const ClaimsRoute = () => {
  return (
    <ClaimsViews>
      <Switch>
        <Route exact path="/:site/claims">
          <Claims />
        </Route>
        <Route exact path="/:site/claims/reports">
          <ClaimReports />
        </Route>
        <Route exact path="/:site/claims/damage-options">
          <DamageOptions />
        </Route>
        <Route path="/:site/claims/create">
          <ClaimsWithCreateDrawer />
        </Route>
        <Route path="/:site/claims/:reclamation/edit">
          <ReclamationEdit />
        </Route>
        <Route path="/:site/claims/:reclamation/complete">
          <ClaimsWithCompleteDrawer />
        </Route>
        <Route path="/:site/claims/:claim">
          <ClaimDetail />
        </Route>
      </Switch>
    </ClaimsViews>
  );
};

export default userHasWarrantyEnabledRedir(ClaimsRoute);
